import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { Button } from 'react-bootstrap';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import './pmProjects.css';

const PmProjects = ({
  fetchPmSities,
  pmSitiesData,
  maintenanceMonth,
  fetchMonth,
  downloadPMList,
  uploadPmList,
  getPmSitiesFilterDropDown,
  pmdropdownList,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [monthId, setMonthId] = useState();
  const [yearId, setYearId] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [uploadModal, setUploadModal] = useState(false);
  const [errorNotFound, setErrorNotFound] = useState(false);
  const [successFull, setSuccessFull] = useState(false);
  const [uploadedSuccessfully, setUploadedSuccessfully] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();
  const openHideModal = () => setOpenModal(false);
  const openDownloadModal = () => setOpenModal(true);
  const hideUploadModal = async () => {
    setUploadModal(false);
  };
  const openUploadModal = async () => {
    setUploadModal(true);
  };

  const handleSuccessFull = () => setSuccessFull(false);

  const headers = [
    'Project ID',
    'Site Number',
    'Client Name',
    'Schd. Mnt. Date',
    'Site Type',
    'Area Name',
    'City',
    'Assigned To',
    'Status',
    // 'Feedback Rating',
    // 'Feedback Remark',
    'Actions',
  ];

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
        setIsRoleId(roles);
      })();
      setIsLoading(false);
    }, 0);
  }, []);

  const headerBtns = () => {
    return (
      <div className="Pm-btn pm-btn-align">
        
      <Fragment>
      
        <Button
          className="btn btn-transparent d-md-inline-block "
          onClick={() => openDownloadModal()}
        >
          {localization.downloadPmList}
        </Button>
        {isRoleId !== 9 && (
          <Fragment>
            
            <Button
              className="btn btn-primary d-md-inline-block "
              onClick={() => openUploadModal()}
            >
              <img src={Images?.ArrowRight} alt=""></img>
              {localization.uploadPmList}
            </Button>
            <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
            >
              <img src={Images?.Filter} alt=""></img>
              {localization.showFilters}
            </Button>
          
          </Fragment>
        )}
      </Fragment>
        </div>
    );
  };

  const headerBtns1 = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    console.log("FILTER",filterData);
    localStorage.setItem("pmList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchPmSities(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchPmSities(filterData, val.selected + 1);

    
    // let filter = filterData === null ? null : filterData;
   
   
    setIsLoading(false);
  };

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("pmSiteCont") &&
        localStorage.getItem("pmSiteCont")
    );
    if(installationCont){
      localStorage.setItem("pmList", JSON.stringify(""));
      localStorage.setItem("pmSiteCont", 0);
    }
    
  }, []);

  useEffect(() => {
    if (fetchPmSities !== null)
      (async () => {
        setIsLoading(true);
        // await fetchPmSities();
        const dashBoardFilter = await JSON.parse(
          localStorage.getItem("dashBoardFilter") &&
            localStorage.getItem("dashBoardFilter")
        );
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("pmList") &&
            localStorage.getItem("pmList")
        );
        if(dashBoardFilter){
          localStorage.setItem("pmList", JSON.stringify(""));
          localStorage.setItem("pmSiteCont", 0);
          await fetchPmSities({
            site_no: '',
            client_name: '',
            site_type: '',
            project_id: '',
            status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:'',
            assignee_ids: '',
            city_id: '',
            fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          });
        }
        else if(getcontractFilter){
          await fetchPmSities(getcontractFilter);
        }
        else{
          await fetchPmSities({
            site_no: '',
            client_name: '',
            site_type: '',
            project_id: '',
            status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:'',
            assignee_ids: '',
            city_id: '',
            fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          });
        }
        // setFilterData({
        //   site_no: '',
        //   client_name: '',
        //   site_type: '',
        //   status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:'',
        //   assignee_ids: '',
        //   fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
        //   toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
        // });
        
        await getPmSitiesFilterDropDown();
        await fetchMonth();
        setIsLoading(false);
        localStorage.setItem("dashBoardFilter", JSON.stringify(''));
      })();
  }, [fetchPmSities]);

  useEffect(() => {
    const actions1 = [
      { name: 'View PM List', link: `/dashboard/view-project-pm-list`},
      { name: 'Manage PM', link: '/dashboard/manage-project-pm' },
    ];

    const action = [
      { name: 'View PM List', link: `/dashboard/view-project-pm-list`},
      { name: 'Change PM Slot', link: '/dashboard/manage-project-pm-slot' },
     ];

    const tableData = [
      'id',
      'site_id',
      'project_id',
      'site_no',
      'client_name',
      'maintaince_date',
      'site_type',
      'area_name',
      'city_name',
      'assigned_to',
      'status',
      // 'feedback_rating',
      // 'feedback_remark'
    ];
    if (pmSitiesData && pmSitiesData.resultSets) {
      const data = pmSitiesData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: isRoleId === 9 ? action : actions1,
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['manage_id'] = obj['id'];
          delete obj['id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });

        newData && setListData(newData);
      }
      setPageCount(Math.ceil(pmSitiesData.total / pmSitiesData.per_page));
    }
  }, [pmSitiesData]);

  const downloadPM = async () => {
    if (monthId && yearId) {
      setIsFiled(false);
      setIsLoading(true);
      const res = await downloadPMList(monthId,yearId);
      setIsLoading(false);
      if (res) {
        window.open(res, '_self');
        setOpenModal(false);
        setErrorNotFound(false);
        setSuccessFull(true);
      } else {
        setErrorNotFound(true);
      }
    } else setIsFiled(true);
  };

  const uploadPM = async () => {
    if (fileUrl !== '') {
      const data = {
        base_64_file: fileUrl,
      };
      const res = await uploadPmList(data);
      fetchPmSities();
      if (res === true) {
        fetchPmSities();
        setUploadModal(false);
        setUploadedSuccessfully(true);
      }
    }
  };

  return (
    <Layout
      title={localization.pmSities}
      Buttons={isRoleId !== 9 ? headerBtns : headerBtns1}
      className={isFiled ? 'requiredFileds' : ''}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        srNo={pmSitiesData?.from}
        onPageChange={onPageChange}
        pageCount={pageCount}
        detailList={pmSitiesData && pmSitiesData.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        // statusId={0}
        isRoleId={isRoleId}
        listFilterData={pmdropdownList?.site_type ? pmdropdownList : null}
        pmdropdownList={true}
        pmApprovalList={false}
      />

      <ModalPop
        title={localization.downloadPmList}
        show={openModal}
        handleModalHide={openHideModal}
        keyboard
        backdrop
      >
        <div className={`text-center ${isFiled ? 'requiredFileds' : ''}`}>
          <DropDownInput
            label={localization.selectMonth}
            data={maintenanceMonth?.month}
            required
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => {
              setMonthId(val.id);
            }}
          />
           <DropDownInput
            label={localization.selectYear}
            data={maintenanceMonth?.year}
            required
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => {
              setYearId(val.id);
            }}
          />
          <Button
            className="btn btn-primary mb-4"
            onClick={() => {
              downloadPM();
            }}
          >
            {localization.downloadPmList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
          <label className={`error ${errorNotFound ? 'd-block' : ''}`}>
            {localization.recordNotFound}
          </label>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.uploadPmList}
        show={uploadModal}
        handleModalHide={hideUploadModal}
        keyboard
        backdrop
      >
        <div className={`text-center ${isFiled ? 'requiredFileds' : ''}`}>
          <FileUpload
            isBase64={true}
            id="bulk_upload"
            accept=".csv"
            onChange={(val) => {
              setFileUrl(val);
            }}
          >
            <span className="btn btn-transparent mb-4">
              {localization.uploadYourFile}
            </span>
          </FileUpload>
          <p>(Upload csv file)</p>
          <Button className="btn btn-primary mb-4" onClick={() => uploadPM()}>
            {localization.uploadPmList} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.conf}
        show={successFull}
        handleModalHide={handleSuccessFull}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.downloadedSuccessfully}</h5>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={uploadedSuccessfully}
        handleModalHide={() => {
          setUploadedSuccessfully(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.uploadedSuccessfully}</h5>
        </div>
      </ModalPop>
    </Layout>
  );
};
export default PmProjects;
